import CacheBase2 from '../../services/engines/CacheBase2';

const _name = 'JxWindowInstanceCache';

/**
 * Tracks open JxForm window instances managed by JxWindowEngine.
 * Each instance: { rk: id, name, props, owner }
 * - id   — stable, assigned by engine (e.g. 'FloatingContentPanel_01', 'JxClockTestForm_01')
 * - name — component type string (e.g. 'JxClockTestForm')
 * - props — current props, may change without affecting id
 * - owner — 'global' | tab id (e.g. 'library', 'dev')
 */
class JxWindowInstanceCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Returns all open window instances.
     * @returns {object[]}
     */
    getAll = () => this._items;

    /**
     * Adds a new window instance.
     * @param {{ id: string, name: string, props: object, owner: string }} instance
     */
    addWindow = (instance) => {
        this.addOrUpdate([{ rk: instance.id, ...instance }]);
    };

    /**
     * Removes a window instance by id.
     * @param {string} id
     */
    removeWindow = (id) => {
        this._items = this._items.filter((w) => w.rk !== id);
    };

    /**
     * Returns next stable id for a given component name.
     * e.g. 'FloatingContentPanel' → 'FloatingContentPanel_01', 'FloatingContentPanel_02'
     * @param {string} name
     * @returns {string}
     */
    getNextId = (name) => {
        const count = this._items.filter((w) => w.name === name).length + 1;
        return `${name}_${String(count).padStart(2, '0')}`;
    };
}

const jxWindowInstanceCache = new JxWindowInstanceCache();
export default jxWindowInstanceCache;
